import objectPath from 'object-path'
import merge from 'deepmerge'
import config from '@/core/config/layout.config.json'
import { logStyles } from '@/main'

// action types
export const SET_LAYOUT_CONFIG = 'setLayoutConfig'
export const RESET_LAYOUT_CONFIG = 'resetLayoutConfig'
export const OVERRIDE_LAYOUT_CONFIG = 'overrideLayoutConfig'
export const OVERRIDE_PAGE_LAYOUT_CONFIG = 'overridePageLayoutConfig'
export const HANDLE_APP_VERSION = 'handleAppVersion'
export const HANDLE_BACKEND_VERSION = 'handleBackendVersion'

// mutation types
export const SET_NEW_VERSION_AVAILABILITY = 'setNewVersionAvailability'

export const GLOBAL_WORDS = {
  success: 'Success!',
  error: 'Oops! Some error occured!',
  work_in_progress: 'Work in progress...',
  unsaved_data: 'You have unsaved data! Are you sure you want to leave?',
}

// mutation types

export default {
  state: {
    config: config,
    initial: config,
    newVersionAvailable: false,
    currentVersion: '0.0.0',
    backendVersion: '0.0.0',
  },
  getters: {
    /**
     * Get config from layout config
     * @param state
     * @returns {function(path, defaultValue): *}
     */
    layoutConfig: (state) => (path, defaultValue) => {
      return objectPath.get(state.config, path, defaultValue)
    },

    currentVersion(state) {
      return state.currentVersion
    },

    backendVersion(state) {
      return state.backendVersion
    },

    newVersionAvailable(state) {
      return state.newVersionAvailable
    },
  },
  actions: {
    /**
     * Set and replace the whole config
     * @param state
     * @param payload
     */
    [SET_LAYOUT_CONFIG](state, payload) {
      state.commit(SET_LAYOUT_CONFIG, payload)
    },

    /**
     * Reset the config at the initial state
     * @param state
     */
    [RESET_LAYOUT_CONFIG](state) {
      state.commit(RESET_LAYOUT_CONFIG)
    },

    /**
     * Reset the config using saved config in the cache by the layout builder
     * @param state
     */
    [OVERRIDE_LAYOUT_CONFIG](state) {
      state.commit(OVERRIDE_LAYOUT_CONFIG)
    },

    /**
     * Override config by page level
     * @param state
     * @param payload
     */
    [OVERRIDE_PAGE_LAYOUT_CONFIG](state, payload) {
      state.commit(OVERRIDE_PAGE_LAYOUT_CONFIG, payload)
    },

    [HANDLE_APP_VERSION](context) {
      let serverVersion
      let isNewVersion
      const timestamp = Date.now()

      console.log(`%c App Version ⇒ v${process.env.APP_VERSION}`, logStyles['version'])
      console.log(' '.repeat(50))

      fetch(`${window.location.origin}/${process.env.VUE_APP_VERSION}?${timestamp}`)
        .then(result => {
          const reader = result.body.getReader()

          reader.read().then(({value}) => {
            const decoder = new TextDecoder('utf-8')
            const stringValue = decoder.decode(value)
            const storedVersion = localStorage.getItem('appVersion')
            serverVersion = stringValue
            isNewVersion = serverVersion > storedVersion
            context.state.currentVersion = storedVersion ? storedVersion : serverVersion
            context.commit(SET_NEW_VERSION_AVAILABILITY, isNewVersion)
            localStorage.setItem('appVersion', serverVersion)

            if (isNewVersion) {
              localStorage.removeItem('serverTableColumns')
              localStorage.removeItem('tariffsTableColumns')
              localStorage.removeItem('userTableColumns')
              localStorage.removeItem('resellerTableColumns')
            }
          })
        })
        .catch(() => {
          localStorage.setItem('appVersion', '0.0.0')
        })
    },

    [HANDLE_BACKEND_VERSION](context, payload) {
      console.log(`%c Backend Version ⇒ v${payload}`, logStyles['version'])
      console.log(' '.repeat(50))

      context.state.backendVersion = payload
    }
  },
  mutations: {
    [SET_LAYOUT_CONFIG](state, payload) {
      state.config = payload
    },
    [RESET_LAYOUT_CONFIG](state) {
      state.config = Object.assign({}, state.initial)
    },
    [OVERRIDE_LAYOUT_CONFIG](state) {
      state.config = state.initial = Object.assign(
        {},
        state.initial,
        JSON.parse(localStorage.getItem('config'))
      )
    },
    [OVERRIDE_PAGE_LAYOUT_CONFIG](state, payload) {
      state.config = merge(state.config, payload)
    },
    [SET_NEW_VERSION_AVAILABILITY](state, result) {
      state.newVersionAvailable = result
    },
  },
}
